import React, { useContext } from "react"; 
import { LanguageContext } from "../context/LanguageContext"
 
 function Footer() {

    const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones

    return (
    <>
    <div class= "footer">

                

                <h2>{t('headContact')}</h2>
                <div class= "footer">        
         
                  {/*}  <p className="text2">
                        {t("headCont1")} 
                    </p>
                    */}
                    <p>E-mail: <a href="mailto:info@techtalamo.com" > info@techtalamo.com</a>      
                    <a>  Phone: +57 3152426950 </a>       
                    </p>    
                </div>
       
        <div>
            <p> Created By Techtalamo LLC 2025 * Copyright &bull; &copy; &bull; All rights reserved </p>
        </div>

    </div>
    </>
    )
    }
    export default Footer